import React from 'react';
import { SelectOption } from 'global';
import { grey } from '@mui/material/colors';
import { SelectField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { Stack, Typography } from '@mui/material';

import { LenderDeskingPanelFormValues, LenderDeskingSections } from '../../../types';

const decisionOptions: SelectOption[] = [
  { value: '803370002', label: 'Declined' },
  { value: '803370003', label: 'Approved' },
  { value: '803370004', label: 'Pre-Approved' },
  { value: '803370000', label: 'Awaiting Review' },
  { value: '803370001', label: 'Requested Additional Information' },
];

interface Props {
  value: LenderDeskingSections;
}

export const DecisionSection = (_: Props) => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  return (
    <Stack
      gap="1rem"
      direction="row"
      alignItems="center"
      sx={{ padding: '1rem 1.5rem', border: `1px solid ${grey[300]}`, borderRadius: '0.25rem' }}
    >
      <Typography variant="h6" component="span">
        Decision
      </Typography>

      <SelectField
        control={control}
        variant="outlined"
        label="Decision Status"
        options={decisionOptions}
        name="submission.decision"
        sx={{ maxWidth: '20rem' }}
      />
    </Stack>
  );
};
